import React from 'react';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
// import NewHeader from './NewHeader';

import { FaTachometerAlt, FaUserCircle, FaIdCard, FaShoppingCart, FaMoneyBillWave, FaUsers, FaSitemap, FaUsersCog, FaListAlt, FaHeadset } from 'react-icons/fa';
import NewHeader from './NewHeader';

function NewSidebar() {

  return (
    <div>
      <NewHeader />
      <div className="sidebar" id="sidebar" style={{ height: '100%' }}>
        <Link to="/dashboard"><FaTachometerAlt style={{ marginRight: '8px' }} /> Dashboard</Link>
        <Link to="/assets"><FaUserCircle style={{ marginRight: '8px' }} /> Account</Link>
        <Link to="/bankbox"><FaIdCard style={{ marginRight: '8px' }} /> KYC</Link>
        <Link to="/my-order"><FaShoppingCart style={{ marginRight: '8px' }} /> Order</Link>
        {/* <Link to="/income"><FaMoneyBillWave style={{ marginRight: '8px' }} /> Income</Link> */}
        <Link to="/direct-team"><FaUsers style={{ marginRight: '8px' }} /> Direct Assoicates</Link>
        {/* <Link to="/genealogy"><FaSitemap style={{ marginRight: '8px' }} /> Genealogy</Link> */}
        <Link to="/all-team"><FaUsersCog style={{ marginRight: '8px' }} /> Total Assoicates</Link>
        <Link to="/visit-site"><FaUsersCog style={{ marginRight: '8px' }} /> Visit Site</Link>
        <Link to="/bonanza-list"><FaUsersCog style={{ marginRight: '8px' }} /> Bonanza</Link>
        <Link to="/rewardIncome"><FaUsersCog style={{ marginRight: '8px' }} /> Rank & Reward</Link>
         <Link to="/map-list"><FaUsersCog style={{ marginRight: '8px' }} />Site Map</Link>
        <Link to="/"><FaUsersCog style={{ marginRight: '8px' }} />Go To Website</Link>
        {/* <Link to="/pv-list"><FaListAlt style={{ marginRight: '8px' }} /> PV List</Link> */}
        {/* <Link to="/support-ticket"><FaHeadset style={{ marginRight: '8px' }} /> Support Ticket</Link> */}
      </div>
      
      <style jsx="true">{`

           .sidebar {
    height: 100%;
    width: 250px;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #dfaa49 !important;
    padding-top: 70px;
    transition: all 0.3s;
    overflow-y: scroll; 
    overflow-x: hidden;
  }

 
  .sidebar::-webkit-scrollbar {
    width: 8px;
  }
  .sidebar::-webkit-scrollbar-track {
    background: #28ad2d;
  }
  .sidebar::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 10px;
    border: 2px solid #28ad2d;
  }
  .sidebar::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }


  .sidebar {
    scrollbar-width: thin;
    scrollbar-color: #888 #1c0f5c;
  }

  .sidebar {
  height: 100vh;
  width: 250px;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #dfaa49 !important;
  padding-top: 70px;
  transition: all 0.3s;
  overflow-y: auto;
  }
        .sidebar a {
          padding: 15px 20px;
          text-decoration: none;
          font-size: 18px;
          color: #000000 !important;
          display: block;
          transition: 0.3s;
        }
        .sidebar a:hover {
          background-color: #33ad28ff !important;
        }
        .header {
          background-color: #1c0f5c;
          height: 60px;
          width: 100%;
          position: fixed;
          top: 0;
          left: 0;
          z-index: 999;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 20px;
          color: #fff;
        }
        .toggle-btn {
          font-size: 24px;
          cursor: pointer;
          color: #fff;
        }
        .main {
          margin-left: 250px;
          padding: 80px 20px 20px 20px;
          transition: all 0.3s;
          min-width: 375px;
        }
        .collapsed .sidebar {
          width: 0;
        }
        .collapsed .main {
          margin-left: 0;
        }
        .profile-card {
          background: radial-gradient(ellipse at center, #b5e2e5 0, #49c8d1 100%);
          padding: 20px;
          border-radius: 15px;
          margin-bottom: 20px;
          text-align: center;
        }
        .copy-btn {
          background: linear-gradient(45deg, #3498db, #1abc9c);
          color: #fff;
          border: none;
          margin-top: 10px;
          padding: 8px 20px;
          border-radius: 20px;
          font-size: 14px;
          cursor: pointer;
          transition: background 0.3s;
        }
        .copy-btn:hover {
          background: linear-gradient(45deg, #1abc9c, #3498db);
        }
        .slider {
          margin-bottom: 20px;
        }
        .slider img {
          width: 100%;
          {/* height: 250px; */}
          object-fit: cover;
          border-radius: 10px;
        }
        .info-cards {
          margin-top: 20px;
        }
        .card-box {
          background: #fff;
          padding: 20px;
          border-radius: 15px;
          text-align: center;
          box-shadow: 0 5px 25px rgba(41, 128, 185, 0.15);
          margin-bottom: 20px;
        }
        .marquee-wrapper {
          margin: 20px 0;
          font-weight: bold;
          color: #1c0f5c;
          font-size: 18px;
        }
    
        @media (max-width: 600px) {
        .sidebar {
          height: 100vh;
          width: 100%;
              
      }
      `}</style>


      {/* <div className="bottom-navbar d-md-none">
  <a href="/"><i className="fa fa-home"></i><br />Home</a>
  <a href="/dashboard"><i className="fa fa-coins"></i><br />dashboard</a>
  <a href="/myabout"><i className="fa fa-users"></i><br />About</a>
  <a href="/blognew"><i className="fa fa-user"></i><br />blognew</a>
</div> */}
    </div>
  );
}

export default NewSidebar;
